import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg } from "../../lib/api";
import { DashboardShell } from "../../components/DashboardShell";
import { StatusPill } from "../../components/StatusPill";

export default function AdminUserChart() {
  const { userId } = useParams();
  const [chart, setChart] = useState(null);

  useEffect(() => {
    api.get(`/admin/users/${userId}/chart`).then((r) => setChart(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [userId]);

  if (!chart) return <DashboardShell title="Chart"><div className="h-8 w-8 rounded-full border-2 border-[#1E3F20] border-t-transparent animate-spin" /></DashboardShell>;

  const u = chart.user;
  const isClinician = u.role === "clinician";

  return (
    <DashboardShell title={u.name}
      subtitle={`${u.account_type === "TEST" ? "[TEST CLIENT] " : ""}${u.role === "admin" ? "Administrator / QA" : u.role} · ${u.email}${u.credentials ? ` · ${u.credentials}` : ""}${u.license_state ? ` · ${u.license_state}` : ""} · joined ${new Date(u.created_at).toLocaleDateString()}`}>
      {isClinician && chart.stats && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-testid="clinician-chart-stats">
          {[["Open slots", chart.stats.open_slots], ["Booked appointments", chart.stats.booked_slots],
            ["Interviews", chart.stats.interviews], ["Reports submitted", chart.stats.reports_submitted]].map(([k, v]) => (
            <div key={k} className="card-warm p-5" data-testid={`stat-${k.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              <p className="text-[11px] tracking-[0.15em] uppercase font-bold text-[#5C5C57]">{k}</p>
              <p className="font-heading text-3xl font-semibold mt-1">{v}</p>
            </div>
          ))}
        </div>
      )}
      <div className="card-warm overflow-hidden" data-testid="user-chart-cases">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs tracking-[0.15em] uppercase text-[#5C5C57] border-b border-[#E5E5DF]">
              {isClinician && <th className="px-6 py-4">Client</th>}
              <th className="px-6 py-4">Evaluation</th>
              <th className="px-6 py-4 hidden md:table-cell">Opened</th>
              <th className="px-6 py-4 hidden md:table-cell">Interview</th>
              <th className="px-6 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {chart.cases.length === 0 && (
              <tr><td colSpan={5} className="px-6 py-10 text-center text-[#5C5C57]" data-testid="chart-no-cases">No evaluations yet.</td></tr>
            )}
            {chart.cases.map((c) => (
              <tr key={c.id} className="border-b border-[#E5E5DF] last:border-0" data-testid={`chart-case-${c.id}`}>
                {isClinician && <td className="px-6 py-3 font-semibold">{c.client?.name}</td>}
                <td className="px-6 py-3 text-[#5C5C57]">{c.product?.name}</td>
                <td className="px-6 py-3 hidden md:table-cell text-[#5C5C57]">{new Date(c.created_at).toLocaleDateString()}</td>
                <td className="px-6 py-3 hidden md:table-cell text-[#5C5C57]">{c.appointment ? new Date(c.appointment.start).toLocaleString() : "—"}</td>
                <td className="px-6 py-3"><StatusPill status={c.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardShell>
  );
}
